import {useLocation} from "react-router-dom";
import {useTranslation, withTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import _ from "lodash";
import {Timeline} from "antd";
import comunidades from "../../../../_constants/comunidades";

function Tek2Bac(props) {
    const {t, i18n} = useTranslation();
    const [timelineData, setTimelineData] = useState([]);

    const {query, search} = useLocation();
    const year = +new URLSearchParams(search).get('year');

    const getPoints = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment.order === code
        });
        if (mResult && mResult[0]){
            if (mResult[0].points === 999){
                return mResult[0].points;
            }
            return mResult[0].points;

        }
        return 0;
    }


    const getResponse = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]){
            if (mResult[0].assessment.questionType=== "COMAUT") {
                let mCom = _.filter(
                    comunidades, function(o) {
                        return o.code === mResult[0].points;
                    }
                );

                if (mCom && mCom[0]) return  mCom[0].name;

                return "";

            }else if (mResult[0].assessment.questionType=== "MULTIPLE3" || mResult[0].assessment.questionType=== "MULTIPLE2" || mResult[0].assessment.questionType=== "MULTIPLE4") {
                let mText = mResult[0].subanswers.map(sub => sub.response.question).join(', ')

                return mText

            }else {
                if (mResult[0].response) {
                    return mResult[0]?.response?.question
                } else {
                    if (mResult[0].degree) {
                        return mResult[0]?.degree?.title
                    }else{
                        if (mResult[0].subject) {
                            return mResult[0]?.subject?.subject
                        }
                    }
                }
            }
        }else{
            return "";
        }
    }


    const getResponseModality = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]) {

            return mResult[0]?.subject?.modality


        } else {
            return "";
        }
    }

    const getResponseSubject = (code, pos) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]){
          if (pos === 0){
              return mResult[0]?.subject?.subject
          }
            let order = _.orderBy(mResult[0]?.subanswers, ["subject.order"],['asc']);

            if (pos === 1){
                return order[0]?.subject?.subject + ", " +  order[1]?.subject?.subject
            }
            if (pos === 2){
                return order[2]?.subject?.subject
            }
        }else{
            return "";
        }
    }

    useEffect(() => {
        let mTimeline =
        [
            { color: '#20388F',
                date:'20' + year + ' - 20' + (year+1),
                message: '<strong>' + t("tengo") + '</strong>: ' + getResponse(2) + '<br />'
                    + '<strong>' + t("tek.duranteeste") + '</strong>: ' + getResponse(5) + '<br /><br />'
                    +'<strong>' +  t("tek.mbtx") + '</strong>: ' + (year < 23 ? getResponse(3) : getResponseModality(3)) + '<br /><br />'
                    + (year > 22 && getResponse(3) !== 999  ?  '<strong>' + t("tek.mitroncal") + '</strong>: ' + getResponseSubject(3,0) + '<br /><br />' : '')
                    + (year > 22 && getResponse(3) !== 999  ?  '<strong>' + t("tek.miespec") + '</strong>: ' + getResponseSubject(3,1) + '<br /><br />' : '')
                    + (year > 22 && getResponse(3) !== 999  ?  '<strong>' + t("tek.miopta") + '</strong>: ' + getResponseSubject(3,2) + '<br /><br />' : '')

                    + '<strong>' + t("tek.satisfecho") + '</strong>: ' + getResponse(4) + '<br /><br />'
                    + '<strong>' + t("tek.titulob") + '</strong>: ' + getResponse(6) + '<br /><br />'
                    + '<strong>' + t("tek.pruebaacc3") + '</strong>: ' + getResponse(14) + '<br /><br />'
                    + '<strong>' + t("tek.notad") + '</strong>: ' + getResponse( 17) + '<br /><br />'
            },
            {  color: '#52C41A',
                date:'20' + (year+1) + ' - 20' + (year+2),
                message: '<strong>' + t("tek.encasobacn") + '</strong>: ' + getResponse(7) + '<br />'
                    + (getPoints(8) !== 999 ? '<strong>' + t("tek.mcfgs") + '</strong>: ' + getResponse(8) + '<br /><br />' : '<br /><br />')
                    + (getPoints(10) !== 999 ? '<strong>' + t("tek.mi1o") + '</strong>: ' + getResponse(10) + '<br /><br />' : '<br /><br />')
                    + (getPoints(11) !== 999 ? '<strong>' + t("tek.mi2o") + '</strong>: ' + getResponse(11) + '<br /><br />' : '<br /><br />')
                    + (getPoints(12) !== 999 ? '<strong>' + t("tek.mi3o") + '</strong>: ' + getResponse(12) + '<br /><br />' : '<br /><br />')
                    + (getPoints(13) !== 999 ? '<strong>' + t("tek.mi4o") + '</strong>: ' + getResponse(13) + '<br /><br />' : '<br /><br />')
                    + ( (getPoints(10) !== 999
                        || getPoints(11) !== 999
                        || getPoints(12) !== 999
                        || getPoints(13) !== 999 ) ? '<strong>' + t("tek.estudiarenu") + '</strong>: ' + getResponse(15) + '<br /><br />' : '<br /><br />')
                    + '<strong>' + t("tek.estudiarenc") + '</strong>: ' + getResponse(16) + '<br /><br />'
            },
            {  color: '#20388F',
                date:'20' + (year+2) + ' - 20' + (year+3),
                message: (getPoints(8) !== 999 ? '<strong>' + t("tek.segundogs") + '</strong>: ' + getResponse(8) + '<br /><br />' : '<br /><br />')
                    + (getPoints(10) !== 999 ? '<strong>' + t("tek.segundocc") + '</strong>: ' + getResponse(10) + '<br /><br />' : '<br /><br />')

            },
            {  color: '#6882DE',
                date:'20' + (year+3) + ' - 20' + (year+4),
                message: (getPoints(8) !== 999 ? '<strong>' + t("tek.encasocfgs") + '</strong>: ' + getResponse(9) + '<br /><br />' : '<br /><br />')

            }
        ];
        props.setTimeline(mTimeline)
        setTimelineData(mTimeline)
    },[year])

    return (
        <>
            {!props.forDownload &&
            <Timeline mode={'left'}>
                {timelineData.map(item=><Timeline.Item    color={item.color} key={item.date} label={item.date}>
                        <p dangerouslySetInnerHTML={{__html: item.message}} />
                    </Timeline.Item>
                )}
            </Timeline>}
        </>
    );
}

export default withTranslation()(Tek2Bac);
